// [2026-10-29] แปลทั้งเว็บ 5 ภาษา (ไทย / English / ລາວ / 中文 / မြန်မာ) แบบไม่ต้องแก้ทุกหน้า
//   หลักการ: ดูข้อความที่แสดงบนจอ (text node + placeholder/title/alt/ปุ่ม) ที่เป็นภาษาไทย → แทนด้วยคำแปลจากพจนานุกรม (i18nDict*.js)
//   - ข้อความที่ React เปลี่ยนทีหลัง (ยอดเงิน, popup, SweetAlert, toast) จับด้วย MutationObserver แล้วแปลให้อัตโนมัติ
//   - เก็บต้นฉบับไทยไว้ที่ node → สลับภาษาไปมา/กลับเป็นไทยได้ทันทีไม่ต้องรีโหลด
//   - ข้อความจากหลังบ้าน (ชื่อเกม/โปรโมชั่นที่แอดมินพิมพ์) ถ้าแปลได้ไม่ถึง ~70% จะคงภาษาไทยไว้ (กันขึ้นครึ่งไทยครึ่งอังกฤษ)
//   - ไม่ต้องการให้แปลส่วนไหน: ใส่ data-noi18n ที่ element นั้น
//   ภาษาเก็บที่ localStorage 'lang' (คีย์เดียวกับหน้าโยกเครดิต / เว็บอื่นในระบบ)
import D1 from './i18nDict1';
import D2 from './i18nDict2';
import D3 from './i18nDict3';
import D4 from './i18nDict4';

export const LANGS = [
  { code: 'th', label: 'ภาษาไทย', short: 'TH', img: 'https://flagcdn.com/w40/th.png' },
  { code: 'en', label: 'English', short: 'EN', img: 'https://flagcdn.com/w40/gb.png' },
  { code: 'lo', label: 'ພາສາລາວ', short: 'LO', img: 'https://flagcdn.com/w40/la.png' },
  { code: 'zh', label: '中文', short: 'ZH', img: 'https://flagcdn.com/w40/cn.png' },
  { code: 'my', label: 'မြန်မာ', short: 'MY', img: 'https://flagcdn.com/w40/mm.png' },
];
const IDX = { en: 0, lo: 1, zh: 2, my: 3 };
const TH = /[\u0E01-\u0E3A\u0E40-\u0E5B]/;
const THG = /[\u0E01-\u0E3A\u0E40-\u0E5B]/g;
const norm = (s) => String(s || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();

const DICT = new Map();
[D1, D2, D3, D4].forEach((d) => Object.keys(d || {}).forEach((k) => DICT.set(norm(k), d[k])));
// คำยาวก่อน (แทนวลียาวก่อนคำสั้น) — ใช้เฉพาะคำ >= 3 ตัวอักษรตอนแทนบางส่วน
const SUBKEYS = Array.from(DICT.keys()).filter((k) => k.length >= 4 && TH.test(k)).sort((a, b) => b.length - a.length);

export function getLang() {
  try { const l = String(localStorage.getItem('lang') || 'th').toLowerCase(); return LANGS.some((x) => x.code === l) ? l : 'th'; } catch (e) { return 'th'; }
}
let LANG = getLang();
const cache = new Map(); // lang|text -> แปลแล้ว
const UNITS = {
  en: { baht: 'THB', hr: '', ppl: 'people' }, lo: { baht: 'ບາດ', hr: ' ໂມງ', ppl: 'ຄົນ' },
  zh: { baht: '泰铢', hr: '', ppl: '人' }, my: { baht: 'ဘတ်', hr: '', ppl: 'ဦး' },
};

export function tr(text, lang = LANG) {
  if (lang === 'th' || !text || !TH.test(text)) return text;
  const ck = lang + '|' + text;
  if (cache.has(ck)) return cache.get(ck);
  const i = IDX[lang];
  const n = norm(text);
  let out = null;
  const hit = DICT.get(n);
  if (hit && hit[i]) {
    const lead = (text.match(/^\s*/) || [''])[0], trail = (text.match(/\s*$/) || [''])[0];
    out = lead + hit[i] + trail;
  } else {
    // แทนบางส่วน (ข้อความต่อกันจากหลายชิ้น เช่น "ยอดฝากรวม " + ตัวเลข)
    const before = (n.match(THG) || []).length;
    let s = text.replace(/\u00a0/g, ' ');
    // ตัวเลข + หน่วย (บาท / น. / คน) ที่ต่อกับค่าตัวเลขจาก API
    const U = UNITS[lang];
    s = s.replace(/(\d[\d,]*(?:\.\d+)?)\s*บาท/g, '$1 ' + U.baht)
      .replace(/(\d{1,2}[:.]\d{2})\s*น\./g, '$1' + U.hr)
      .replace(/(\d[\d,]*)\s*คน/g, '$1 ' + U.ppl);
    for (const k of SUBKEYS) {
      if (s.indexOf(k) >= 0) { const v = DICT.get(k)[i]; if (v) s = s.split(k).join(lang === 'en' ? ' ' + v + ' ' : v); }
    }
    if (lang === 'en') s = s.replace(/ {2,}/g, ' ').replace(/ ([,.:;!?)\]])/g, '$1').replace(/([(\[]) /g, '$1');
    const lead0 = (text.match(/^\s*/) || [''])[0], trail0 = (text.match(/\s*$/) || [''])[0];
    s = lead0 + s.trim() + trail0;
    const left = (s.match(THG) || []).length;
    out = before && left / before <= 0.15 ? s : text; // แปลไม่ถึง 85% → คงไทย (กันขึ้นครึ่งไทยครึ่งแปล)
  }
  cache.set(ck, out);
  return out;
}

// ---------- แปลบนหน้าเว็บ ----------
const ATTRS = ['placeholder', 'title', 'alt', 'aria-label'];
const SKIP_TAGS = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1, CODE: 1 };
function skipEl(el) {
  if (!el || el.nodeType !== 1) return true;
  if (SKIP_TAGS[el.tagName]) return true;
  if (el.isContentEditable) return true;
  return !!(el.closest && el.closest('[data-noi18n]'));
}
function doText(node) {
  const p = node.parentNode;
  if (!p || skipEl(p)) return;
  const v = node.nodeValue;
  if (v !== node.__i18nOut) node.__i18nTh = v; // React เปลี่ยนข้อความใหม่ = ต้นฉบับใหม่
  const src = node.__i18nTh;
  if (src == null || !TH.test(src)) return;
  const out = LANG === 'th' ? src : tr(src);
  node.__i18nOut = out;
  if (node.nodeValue !== out) node.nodeValue = out;
}
function doAttrs(el) {
  if (skipEl(el)) return;
  const st = el.__i18nAttr || (el.__i18nAttr = {});
  const names = ATTRS.slice();
  if (el.tagName === 'INPUT' && /^(button|submit|reset)$/i.test(el.type || '')) names.push('value');
  for (const a of names) {
    const v = el.getAttribute(a);
    if (v == null) continue;
    const rec = st[a] || (st[a] = {});
    if (v !== rec.out) rec.th = v;
    if (!rec.th || !TH.test(rec.th)) continue;
    const out = LANG === 'th' ? rec.th : tr(rec.th);
    rec.out = out;
    if (v !== out) el.setAttribute(a, out);
  }
}
function walk(root) {
  if (!root) return;
  if (root.nodeType === 3) { doText(root); return; }
  if (root.nodeType !== 1 || skipEl(root)) return;
  doAttrs(root);
  const tw = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, null);
  let n = tw.nextNode();
  while (n) {
    if (n.nodeType === 3) doText(n); else doAttrs(n);
    n = tw.nextNode();
  }
}
let titleTh = null;
function doTitle() {
  const t = document.title;
  if (t !== doTitle.out) titleTh = t;
  if (!titleTh || !TH.test(titleTh)) return;
  doTitle.out = LANG === 'th' ? titleTh : tr(titleTh);
  if (document.title !== doTitle.out) document.title = doTitle.out;
}

const queue = new Set();
let scheduled = false;
function flush() {
  scheduled = false;
  const items = Array.from(queue); queue.clear();
  obs.disconnect();
  try { items.forEach(walk); doTitle(); } finally { observe(); }
  placeSwitcher();
}
function schedule(n) { queue.add(n); if (!scheduled) { scheduled = true; requestAnimationFrame(flush); } }
const obs = new MutationObserver((muts) => {
  for (const m of muts) {
    if (m.type === 'characterData') schedule(m.target);
    else if (m.type === 'attributes') schedule(m.target);
    else m.addedNodes.forEach((n) => schedule(n));
  }
});
function observe() {
  obs.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ATTRS.concat(['value']) });
  const t = document.querySelector('title'); if (t) obs.observe(t, { childList: true, characterData: true, subtree: true });
}

export function setLang(code) {
  if (!LANGS.some((x) => x.code === code)) code = 'th';
  try { localStorage.setItem('lang', code); } catch (e) { }
  LANG = code;
  document.documentElement.setAttribute('lang', code);
  obs.disconnect();
  try { walk(document.body); doTitle(); } finally { observe(); }
  renderSwitcher();
  try { window.dispatchEvent(new CustomEvent('site-lang', { detail: code })); } catch (e) { }
}

// ---------- ปุ่มเลือกภาษา (อยู่ในแถบเมนูบน ชิดซ้ายของปุ่มเข้าสู่ระบบ/ยอดเงิน — ทั้งมือถือและคอม) ----------
let sw = null;
const SW_CSS = `
#i18n-switch{position:fixed;top:14px;right:12px;z-index:1031;font-family:inherit;visibility:hidden}
#i18n-switch.ready{visibility:visible}
#i18n-switch .ls-btn{display:flex;align-items:center;gap:6px;height:32px;padding:0 10px 0 6px;border-radius:999px;cursor:pointer;user-select:none;
  background:rgba(0,0,0,.35);border:1px solid rgba(255,255,255,.35);color:#fff;font-size:13px;font-weight:700;line-height:1;transition:.15s}
#i18n-switch .ls-btn:hover,#i18n-switch.open .ls-btn{border-color:var(--primary,#fbc844);background:rgba(0,0,0,.55)}
#i18n-switch .ls-btn img{width:22px;height:22px;border-radius:50%;object-fit:cover;border:1px solid rgba(255,255,255,.5)}
#i18n-switch .ls-caret{font-size:9px;opacity:.75;transition:transform .15s}
#i18n-switch.open .ls-caret{transform:rotate(180deg)}
#i18n-switch .ls-menu{position:absolute;right:0;top:calc(100% + 8px);min-width:170px;background:#1c1c1c;border:1px solid rgba(255,255,255,.15);
  border-radius:14px;padding:6px;box-shadow:0 14px 30px rgba(0,0,0,.5);opacity:0;transform:translateY(-6px);pointer-events:none;transition:.15s}
#i18n-switch.open .ls-menu{opacity:1;transform:none;pointer-events:auto}
#i18n-switch .ls-item{display:flex;align-items:center;gap:10px;padding:9px 10px;border-radius:10px;color:#fff;cursor:pointer;font-size:14px;white-space:nowrap}
#i18n-switch .ls-item img{width:22px;height:22px;border-radius:50%;object-fit:cover}
#i18n-switch .ls-item:hover{background:rgba(255,255,255,.08)}
#i18n-switch .ls-item.on{background:rgba(255,255,255,.12);color:var(--primary,#fbc844);font-weight:800}
#i18n-switch .ls-item.on::after{content:'✓';margin-left:auto}
@media (max-width:575px){
  #i18n-switch .ls-btn{height:30px;padding:0 7px 0 4px;gap:4px;font-size:12px}
  #i18n-switch .ls-btn img{width:20px;height:20px}
}`;

// หาตำแหน่ง: กึ่งกลางแนวตั้งของ navbar และอยู่ซ้ายของกลุ่มปุ่มฝั่งขวา (เข้าสู่ระบบ / สมัคร / ยอดเงิน)
function rightEdgeOfHeader(nav) {
  let left = Infinity;
  const nr = nav.getBoundingClientRect();
  nav.querySelectorAll('#headerContent, .x-logged, .navbar-nav, a.btn, button').forEach((el) => {
    if (el.closest('#headerBrand') || el.closest('#i18n-switch')) return;
    const r = el.getBoundingClientRect();
    if (!r.width || !r.height || r.top > nr.bottom || r.bottom < nr.top) return;
    if (r.left > nr.left + nr.width * 0.35 && r.left < left) left = r.left;
  });
  return left === Infinity ? null : left;
}
let placeReq = 0;
function placeSwitcher() {
  if (!sw || placeReq) return;
  placeReq = requestAnimationFrame(() => {
    placeReq = 0;
    const nav = document.querySelector('nav.x-header, #navbar');
    const h = sw.offsetHeight || 32, w = sw.offsetWidth || 70;
    let top = 14, right = 12;
    if (nav && nav.getBoundingClientRect().height > 20 && getComputedStyle(nav).display !== 'none') {
      const nr = nav.getBoundingClientRect();
      top = Math.max(4, Math.round(nr.top + (nr.height - h) / 2));
      const edge = rightEdgeOfHeader(nav);
      right = edge != null ? Math.round(window.innerWidth - edge + 8) : Math.round(window.innerWidth - nr.right + 12);
      // ถ้าชนโลโก้ (จอแคบมาก) → ชิดขวาสุด ใต้แถบเมนู
      const brand = nav.querySelector('#headerBrand');
      const bR = brand ? brand.getBoundingClientRect().right : 0;
      if (window.innerWidth - right - w < bR + 6) { top = Math.round(nr.bottom + 6); right = 8; }
    }
    sw.style.top = top + 'px'; sw.style.right = right + 'px';
    sw.classList.add('ready');
  });
}

function renderSwitcher() {
  if (!document.body) return;
  if (!sw) {
    sw = document.createElement('div');
    sw.id = 'i18n-switch';
    sw.setAttribute('data-noi18n', '1');
    const css = document.createElement('style');
    css.textContent = SW_CSS;
    document.head.appendChild(css);
    document.body.appendChild(sw);
    sw.addEventListener('click', (e) => {
      const it = e.target.closest('[data-lang]');
      if (it) { sw.classList.remove('open'); setLang(it.getAttribute('data-lang')); return; }
      if (e.target.closest('.ls-btn')) sw.classList.toggle('open');
    });
    document.addEventListener('click', (e) => { if (sw && !sw.contains(e.target)) sw.classList.remove('open'); });
    window.addEventListener('resize', placeSwitcher);
    window.addEventListener('orientationchange', placeSwitcher);
    setInterval(placeSwitcher, 1500); // เผื่อแถบเมนูเปลี่ยน (login/logout, โหลดยอดเงิน)
  }
  const cur = LANGS.find((l) => l.code === LANG) || LANGS[0];
  sw.innerHTML = '<div class="ls-btn" title="Language"><img src="' + cur.img + '" alt=""><span>' + cur.short + '</span><span class="ls-caret">▼</span></div>' +
    '<div class="ls-menu">' + LANGS.map((l) => '<div class="ls-item' + (l.code === LANG ? ' on' : '') + '" data-lang="' + l.code + '"><img src="' + l.img + '" alt=""><span>' + l.label + '</span></div>').join('') + '</div>';
  placeSwitcher();
}

export function startI18n() {
  const go = () => {
    document.documentElement.setAttribute('lang', LANG);
    renderSwitcher();
    walk(document.body); doTitle();
    observe();
    // หน้าโยกเครดิตเปลี่ยนภาษาจากในหน้า → ให้ทั้งเว็บเปลี่ยนตาม
    window.addEventListener('storage', (e) => { if (e.key === 'lang') setLang(getLang()); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
}
window.siteSetLang = setLang;
